import {
  API_BASE_URL,
  GET,
  ADD,
  UPDATE,
  DELETE,
  QUERY,
  ON_SUBMIT,
  GET_PERMISSIONS
} from "./constants";
import { API, createJsonHeaders } from "app/api";

const fetchResource = collection => params => {
  const url = `${API_BASE_URL}/resources/${collection}/${params.proposalId}`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      collection,
      ...GET
    }
  };
};

export const fetchDraft = fetchResource("drafts");

export const fetchProposal = fetchResource("proposals");

const deleteResource = collection => params => {
  const { proposalId, topicId } = params;
  const url = `${API_BASE_URL}/resources/${collection}/${proposalId}`;
  const request = new Request(url, {
    method: "DELETE",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      proposalId,
      topicId,
      collection,
      ...DELETE
    }
  };
};

export const deleteProposal = deleteResource("proposals");

export const deleteDraft = deleteResource("drafts");

export const createResource = collection => params => {
  const { proposal } = params;
  const url = `${API_BASE_URL}/resources/${collection}/`;
  const body = JSON.stringify(proposal);
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      proposal,
      collection,
      ...ADD
    }
  };
};

// export const createProposal = createResource("proposals");

export const createDraft = createResource("drafts");

export const updateResource = collection => params => {
  const { proposal } = params;
  const url = `${API_BASE_URL}/resources/${collection}/${proposal._id}`;
  const body = JSON.stringify(proposal);
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "PUT",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      proposal,
      collection,
      ...UPDATE
    }
  };
};

// export const updateProposal = updateResource("proposals");

export const updateDraft = updateResource("drafts");

export const queryResources = collection => (params, actionCreators = []) => {
  const url = `${API_BASE_URL}/query/${collection}`;
  const body = JSON.stringify(params);
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      params,
      collection,
      actionCreators,
      ...QUERY
    }
  };
};

export const fetchProposalPermissions = params => {
  const url = `${API_BASE_URL}/permissions/proposals/${params.permission}/${
    params.proposalId
  }`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...GET_PERMISSIONS
    }
  };
};

export const queryProposals = queryResources("proposals");

export const queryDrafts = queryResources("drafts");

export const onSubmitDraft = params => {
  const url = `${API_BASE_URL}/on/drafts/submit/${params.proposalId}`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...ON_SUBMIT
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/proposals/actions.js